__webpack_require__.p = "/Portfolio-react/";